import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/versions/new/variables")({
  staticData: {
    title: "common.variables",
  },
});
